export function extractPetIdFromQrText(value) {
  const text = String(value || "").trim();
  if (!text) return "";

  try {
    const url = new URL(text);
    const queryId =
      url.searchParams.get("id") ||
      url.searchParams.get("petId") ||
      url.searchParams.get("pet_id");

    if (queryId) return queryId.trim();

    const pathParts = url.pathname.split("/").filter(Boolean);
    return decodeURIComponent(pathParts[pathParts.length - 1] || text).trim();
  } catch {
    return text;
  }
}
